
export default {
    name: "ScriptBlok",
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
    head() {
        return {
            style: [
                {
                    innerHTML: this.blok.customCss,
                },
            ],
        }
    },
}
